/// <reference types="react-scripts" />
import * as React from "react";
import { abortManager } from "source/models/services/tokenService";
import { RouteComponentProps } from "react-router-dom";
import { UserInvitationPageContent } from "./UserInvitationPageContent";

export interface IUserInvitationPageOwnProps {
}

export interface IUserInvitationPageStateProps {
}

export interface IUserInvitationPageDispatchProps {
}

export interface IUserInvitationPagePathProps {
    token: string;
}

type UserInvitationPageProp = IUserInvitationPageOwnProps & IUserInvitationPageStateProps & IUserInvitationPageDispatchProps & RouteComponentProps<IUserInvitationPagePathProps>;

export class UserInvitationPage extends React.Component<UserInvitationPageProp, {}> {
    constructor(props: UserInvitationPageProp) {
        super(props);
        abortManager.abortAll(); //Abort all abortable calls regardless of module
    }

    render() {
        return (
            <UserInvitationPageContent
                token={this.props.match.params.token}
            />
        );
    }
}